<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  notes: {
    type: Array,
    default: () => [],
  },
  checklistItems: {
    type: Array,
    default: () => [],
  },
  attachments: {
    type: Array,
    default: () => [],
  },
});

const { t } = useI18n();

const totalChecklistItems = computed(() => props.checklistItems.length);
const completedChecklistItems = computed(() => props.checklistItems.filter(item => item.completed).length);

const itemStatistics = computed(() => {
  const timeInStage = props.item.stage_entered_at
    ? formatDistanceToNow(new Date(props.item.stage_entered_at), { locale: ptBR, addSuffix: false })
    : t('KANBAN.STATISTICS.NOT_AVAILABLE');

  const noteCount = props.notes?.length || 0;
  const checklistProgressText = `${completedChecklistItems.value}/${totalChecklistItems.value}`;
  const attachmentCount = props.attachments?.length || 0;

  return [
    { icon: 'book-clock', label: t('KANBAN.STATISTICS.TIME_IN_STAGE'), value: timeInStage },
    { icon: 'comment-add', label: t('KANBAN.STATISTICS.NOTES'), value: noteCount },
    { icon: 'checkmark-circle', label: t('KANBAN.STATISTICS.CHECKLIST'), value: checklistProgressText },
    { icon: 'attach', label: t('KANBAN.STATISTICS.ATTACHMENTS'), value: attachmentCount },
  ];
});
</script>

<template>
  <div class="item-statistics bg-white dark:bg-slate-800 rounded-lg p-4 border border-slate-200 dark:border-slate-700">
    <h3 class="text-sm font-medium text-slate-900 dark:text-slate-100 mb-3">
      {{ t('KANBAN.STATISTICS.TITLE') }}
    </h3>
    <div class="grid grid-cols-2 gap-4">
      <div
        v-for="stat in itemStatistics"
        :key="stat.label"
        class="flex items-center gap-2 p-2 bg-slate-50 dark:bg-slate-700/50 rounded-lg"
      >
        <fluent-icon
          :icon="stat.icon"
          size="18"
          class="text-slate-500 dark:text-slate-400"
        />
        <div>
          <span class="block text-xs text-slate-500 dark:text-slate-400">
            {{ stat.label }}
          </span>
          <span class="block text-sm font-medium text-slate-800 dark:text-slate-200">
            {{ stat.value }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Adicione estilos específicos se necessário, mas as classes Tailwind devem funcionar */
.item-statistics {
  /* Estilos já aplicados via classes Tailwind */
}
</style> 